export const getWebAnalyticsModule = () => {
  if (typeof window !== 'undefined') {
    return require('@monetization/web-analytics-bundle/dist');
  }
  return null;
};
